<template>
  <div class="future-legend">
    <div class="future-legend__color-blocks">
      <div
        class="future-legend__color-blocks__block"
        v-for="d in colorInfos"
        :key="d"
        :style="{ 'background-color': d }"
      ></div>
    </div>
    <div class="future-legend__lower">
      <div>⟵ more spending</div>
      <div>more savings ⟶</div>
    </div>
  </div>
</template>

<script>
import colors from '@/styles/colors.scss'
export default {
  data() {
    return {
      colorInfos: [
        colors.red4,
        colors.red3,
        colors.red2,
        colors.red1,
        colors.green1,
        colors.green2,
        colors.green3,
        colors.green4
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.future-legend {
  position: absolute;
  height: 50px;
  display: flex;
  flex-flow: column;

  &__color-blocks {
    display: flex;
    flex-flow: row;
    position: relative;
    height: 30px;

    &__block {
      width: 30px;
      height: 100%;

      &:nth-of-type(5) {
        margin-left: 10px;
      }
    }
  }

  &__lower {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    font-size: 12px;
    box-sizing: border-box;
    padding: 0px 5px;
  }
}
</style>
